var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_"},[_c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"view"})],1),_vm._v(" "),(_vm.$store.state.breakpoint === 'initial')?_c('portal-target',{attrs:{"name":"mobile-footer"}}):_vm._e()],1),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e0486d4","hasScoped":false,"optionsId":"4","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/templates/app.vue
// module id = null
// module chunks = 